<script>
    import { selectedItem } from '../../../store/store.js';
</script>

<div class="key-value-table box">
    <h5>Medlemskap</h5>

    <h6 style="font-weight: 500;">Hur ansöker man om medlemskap?</h6>
    <h6>{$selectedItem?.membership?.application_process ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Kan medlemskap nekas? På vilka grunder?</h6>
    <h6>{$selectedItem?.membership?.membership_denial_grounds ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Uteslutning och utträde ur föreningen</h6>
    <h6>{$selectedItem?.membership?.termination_of_membership ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Juridisk person</h6>
    <h6>
        {$selectedItem?.membership?.juridisk_person_is_allowed == null
          ? "Uppgifter saknas"
          : $selectedItem.membership.juridisk_person_is_allowed
            ? "Tillåts"
            : "Tillåts ej"}
    </h6>
</div>